import React from "react";
import { shareableKeys } from "../urlTools";

function useShareable(key: string, shared: boolean) {
  React.useLayoutEffect(() => {
    if (!shared) return;
    shareableKeys.set(key, (shareableKeys.get(key) ?? 0) + 1);
    return () => {
      const shareableCount = shareableKeys.get(key);
      if (shareableCount === undefined || shareableCount < 1)
        throw new Error("Invalid shareableCount");
      if (shareableCount === 1) {
        shareableKeys.delete(key);
      } else shareableKeys.set(key, shareableCount - 1);
    };
  }, [key, shared]);
}

export default useShareable;
